import * as React from "react";
import { Img } from "atoms";
import defaultSRC from "assets/images/default-project-img.svg";
import { Image } from "../types";

type ThumbnailProps = Omit<React.ComponentProps<typeof Img>, "src"> & {
  src?: string | Image;
  small?: boolean;
  avatar?: boolean;
};

const createImgAttributes = (src?: string | Image) => {
  if (!src) {
    return { src: defaultSRC };
  }
  if (typeof src === "string") {
    return { src };
  }
  return {
    src: src.url300 ?? src.url,
    srcSet: src.url300 ? `${src.url300} 300w, ${src.url600} 600w` : undefined,
    sizes: src.url300 ? "(min-width: 800px) 25vw, 96vw" : undefined,
  };
};

/**
 * ProjectCard thumbnail image component
 */
function Thumbnail({
  src,
  // avatar = false,
  ...props
}: ThumbnailProps) {
  const [isError, setIsError] = React.useState(false);

  // Build <img> attributes depending on `src` type
  const attrs = createImgAttributes(src);

  // If optimized src doesn't exist for whatever reason, fallback to original src
  const onError: React.ReactEventHandler<HTMLImageElement> = () => {
    // To prevent endless error loop
    if (!isError) setIsError(true);
  };

  // css={avatar ? avatarCSS : {}}
  return (
    <Img
      {...attrs}
      src={isError ? defaultSRC : attrs.src}
      onError={onError}
      {...props}
    />
  );
}

export { Thumbnail };
